import AbstractRepository from "@/repositories/AbstractRepository";

export default class RequestRepository extends AbstractRepository {
    protected static resource: string = "ptf-request-request";

    protected static defaultFields: string[] = [
        "uuid",
        "title",
        "description",
        "beginDate",
        "endDate",
        "area",
        "brief",
        "orderNumber",
        "code",
        "status",
        "type.label",
        "type.uuid",
        "owner.uuid",
        "owner.fullName",
        "topic.uuid",
        "subtopic.uuid",
        "allocations.uuid",
        "allocations.amount",
        "allocations.amountMin",
        "allocations.budgetAllocation.uuid",
        "createdAt",
        "createdBy.uuid",
        "createdBy.displayName",
        "children.uuid",
        "children.code",
        "children.title",
        "children.status",
        "children.description",
        "children.beginDate",
        "children.endDate",
        "children.area",
        "children.brief",
        "children.type.label",
        "children.type.uuid",
        "children.children.uuid",
        "children.orderNumber",
        "children.owner.uuid",
        "children.topic.uuid",
        "children.subtopic.uuid",
        "children.allocations.uuid",
        "children.allocations.amount",
        "children.allocations.amountMin",
        "children.allocations.budgetAllocation.uuid",
        "children.createdAt",
        "children.createdBy.uuid",
        "children.createdBy.displayName",
        "children.hierarchyOwner.fullName",
        "children.scopeOwner.uuid",
        "children.hierarchyOwner.uuid",
        "children.wishes.uuid",
        "parent.uuid",
        "hierarchyOwner.address.city",
        "hierarchyOwner.clientCode1",
        "hierarchyOwner.fullName",
        "hierarchyOwner.uuid",
        "wishes.uuid",
        "scopeOwner.uuid",
        "followers.uuid",
        "followers.displayName",
        "mediaCampaign.uuid"
    ];
}
